/* eslint-disable @typescript-eslint/no-explicit-any */
export enum Area {
  AREA = 1,
  PROVINCE = 2,
  DISTRICT = 3,
  WARD = 4,
}

export enum Status {
  ACTIVED = 1,
  DISABLED = 0,
}

export enum Languages {
  VN = 'vi',
  EN = 'en',
}

export enum Platform {
  DESKTOP = 'Desktop',
  MOBILE = 'Mobile',
}
export enum SaleChannel {
  B2C = 'b2c',
  B2E = 'b2e',
}
// Default Miền Bắc
export const DEFAULT_REGION = 'MB'

export enum LabelPosition {
  TOP_LEFT = 'topLeft',
  TOP_MID = 'topMid',
  TOP_RIGHT = 'topRight',
  MID_LEFT = 'midLeft',
  MID_RIGHT = 'midRight',
  BOTTOM_LEFT = 'bottomLeft',
  BOTTOM_MID = 'bottomMid',
  BOTTOM_RIGHT = 'bottomRight',
}
export enum MenuTypes {
  GLOBAL_TOP = 'global_ws_top',
  GLOBAL_QUICK = 'quick_menu',
  GLOBAL_BOTTOM = 'global_ws_bottom',
  HOME_PRODUCT_CAT = 'home_product_cat',
  CATEGORY_MENU = 'category_menu',
  SUGGEST_SEARCH = 'suggest_search',
}
export enum PromotionTypes {
  PROMOTION = 'promotion',
  TRENDING = 'trending',
  BEST_SELLER = 'bestSeller',
  PROMOTION_PAGE = 'promotionPage',
  CMS_PAGE = 'cmsPage',
  PRODUCT_FOR_YOU = 'productForYou',
  PRODUCT_HOT = 'productHot',
  YOUR_PROMOTION = 'homepageYourPromotion',
  LIST_HOT = 'listHot',
  EXCLUSIVE_DEAL = 'exclusiveDeal',
}

export enum MenuItemType {
  LINK = 'link',
  POST = 'post',
  POST_CAT = 'postCat',
  PRODUCT = 'product',
  PRODUCT_CAT = 'productCat',
  PAGE_CMS = 'pageCMS',
}

export enum BannerType {
  TOP_BAR = 'topBarBanner',
  PROMOTION = 'promotionBanner',
  SIDEBAR = 'sideBarBanner',
  MAIN = 'homeMainSlider',
  HOME = 'homeBlockBanner',
  LOGIN = 'loginBanner',
  REGISTER = 'registerBanner',
  FULL_POPUP = 'fullPopup',
  COUNTDOWN_POPUP = 'countdownPopup',
}

export enum PageType {
  PRODUCT = 'products',
  CATEGORY = 'categories',
  POST = 'posts',
  HOMEPAGE = 'homepage',
  SEARCH = 'search',
  CHECKOUT = 'checkout',
  ACCOUNT = 'account',
  PAGE_CMS = 'pageCMS',
}
export enum ProductCardType {
  TRENDING = 'trending',
  RELATED = 'related-product',
  RECOMMENDED = 'recommended',
  RESULT = 'result',
  FLASH_SALE = 'flashSale',
  PRODUCT_CARD = 'product-card',
  PRODUCT_DETAIL = 'product-detail',
  LIST_HOT = 'listHot',
  PRODUCT_LIST_CMS = 'productListCMS',
  PRODUCT_TAB_CMS = 'productTabCMS',
  PRODUCT_LIST_FULL_CMS = 'productListFullCMS',
}

export enum PageTypeSuffix {
  POST = '.b',
  CATEGORY = '.c',
  PAGE_CMS = '.p',
}

export const PHONE_REGEXP = new RegExp(
  /^(0|84)(2(0[3-9]|1[0-6|8|9]|2[0-2|5-9]|3[2-9]|4[0-9]|5[1|2|4-9]|6[0-3|9]|7[0-7]|8[0-9]|9[0-4|6|7|9])|3[2-9]|5[5|6|8|9]|7[0|6-9]|8[0-6|8|9]|9[0-4|6-9])([0-9]{7})$/
)

export enum AddToCartType {
  BUY_NOW = 'buy-now',
  CONTACT = 'contact',
  DISABLED = 'disable',
  ADD = 'add-to-cart',
  INSTALLMENT = 'installment',
  OUT_OF_BUSINESS = 'outOfBusiness',
  PRE_ORDER = 'preOrder',
}
export const TIMES = [
  { label: '09:00 - 12:00', value: '09:00:00:000', hour: 12 },
  { label: '12:00 - 14:00', value: '12:00:00:000', hour: 14 },
  { label: '14:00 - 16:00', value: '14:00:00:000', hour: 16 },
  { label: '16:00 - 18:00', value: '16:00:00:000', hour: 18 },
  { label: '18:00 - 20:00', value: '18:00:00:000', hour: 20 },
]

export enum RadioGroupType {
  CHOOSE_PAYMENT = 'CHOOSE_PAYMENT',
  PAYMENT = 'PAYMENT',
}

export enum PAYMENT_STATUS {
  WAIT_TO_PAY = 'waitToPay',
  PAID = 'paid',
  SUCCESS = 'success',
  FAILED = 'failed',
  TIMEOUT = 'timeout',
  CANCELLED = 'cancelled',
}

export enum OrderStatus {
  WAIT_TO_CONFIRM = 'waitToConfirm',
  CONFIRMED = 'confirmed',
  SHIPPING = 'shipping',
  SHIPPED = 'shipped',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  PARTIAL_SHIPPED = 'partialShipped',
  CANCELED_BY_USER = 'canceledByUser',
  REFUNDED = 'refunded',
  RETURNED = 'returned',
  DEBT_OVER_DUE = 'debtOverdue',
  PAID = 'paid',
  HANG_UP_PAYMENT = 'hangUpPayment',
  PROCESSING = 'processing',
}

export enum PAYMENT_METHODS {
  COD = 'COD',
  BANK_TRANSFER = 'bankTransfer',
  ATM = 'atm',
  INSTALLMENT = 'installment',
  QR_CODE = 'qrcode',
  PRE_ORDER = 'preOrder',
  CREDIT_CARD = 'creditCard',
}
export enum PaymentProviderType {
  ECOPAY = 'ECOPAY',
  ONEPAY = 'ONEPAY',
  TECHCOMBANK = 'TCB',
}
export enum BANK_TYPES {
  DOMESTIC = 'domestic',
  INTERNATIONAL = 'international',
}

export enum ServiceType {
  SHIPPING = 'shipping',
  SHIPPING_AND_INSTALL = 'shippingAndInstall',
}

export enum SHIPPING_METHOD {
  STANDARD = 'standard',
  PICKUP_IN_STORE = 'pickUpInStore',
}
export enum StoreType {
  CENTER = 'center',
  SHOP = 'shop',
  WAREHOUSE = 'warehouse',
}
export enum API_STATUS_CODE {
  UNSUPPORTED = 'UNSUPPORTED',
  PRODUCT_OUT_OF_STOCK = 'PRODUCT_OUT_OF_STOCK',
  PRODUCT_LIMIT_SALE = 'PRODUCT_LIMIT_SALE',
}
export enum VoucherTypes {
  PERCENT = 'percent',
  FIXED = 'fixed',
}

export enum ProductStockStatus {
  OUT_OF_STOCK = 'outOfStock',
  OUT_OF_BUSINESS = 'outOfBusiness',
  INCOMING = 'incoming',
  ARRIVING = 'arriving',
  IN_STOCK = 'inStock',
}
export enum BLOCK_CMS_TYPE {
  BANNER_ONE_LINE = 'bannerOneLine',
  BANNER_22 = 'banner22',
  PRODUCT_LIST = 'productList',
  PRODUCT_TAB = 'tabProduct',
  SLIDER = 'bannerSlider',
  TAB_SCROLL = 'tabScroll',
  PRODUCT_LIST_FULL = 'productListFull',
}

export enum FlashSaleType {
  FLASH_SALE = 'flashSale',
  PROMOTION = 'promotion',
}
export enum DepositStatus {
  DEPOSITED = 'deposited',
  UN_DEPOSITED = 'unDeposited',
}
export enum CouponType {
  COUPON = 'coupon',
  PRODUCT = 'product',
  SERVICE = 'service',
}

export const PAYMENT_PA_STATUS = {
  NO_VERIFY: 'U',
}

export enum CouponTarget {
  ORDER = 'order',
  PRODUCT = 'product',
}
export function mapToProductSchema(data: any) {
  return {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: data.name?.vi || 'Unnamed Product',
    image: data.images || [],
    description:
      data.metaDescription?.vi ||
      data.shortDescription?.vi ||
      'No description available',
    sku: data.code || 'Unknown SKU',
    mpn: data.erpSku || 'Unknown MPN',
    brand: {
      '@type': 'Brand',
      name: data?.brand?.vi || 'Unknown Brand',
    },
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/' + (data.stockStatus || 'OutOfStock'),
      price: data.salePrice || data.price || '0',
      priceCurrency: 'VND',
    },
    review: [
      {
        '@type': 'Review',
        author: 'Anonymous',
        datePublished: new Date(data.createdAt).toISOString(),
        reviewBody: 'Default review content.',
        name: 'Default review title.',
        reviewRating: {
          '@type': 'Rating',
          bestRating: '5',
          ratingValue: data.review?.point?.toString() || '0',
          worstRating: '1',
        },
      },
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: data?.review?.point,

      ratingCount: data?.review?.turn,
      reviewCount: data?.review?.turn,
    },
    additionalProperty: [
      ...(data.outstandingFeatures || []).map(
        (feature: { value: { vi: string } }) => ({
          '@type': 'PropertyValue',
          name: feature.value?.vi || 'Unknown Feature',
          value: 'Yes',
        })
      ),
    ],
  }
}
